import { CommunityWithPrimary } from './community-with-primary.model';
import { UserType } from './user-type.model';

export const COMMUNITY_MANAGER_ID = '3';
export class CommunityWithRoles extends CommunityWithPrimary {
    public roles: UserType[];
    public numberOfCommunityUsers: number;
}
